import { authenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

export const getMenuItems_api = async ({ id, params }) => {
	if (id) {
		const response = await authenticatedApi.get(
			`${MICROSERVICE_CONFIG.RESTAURANT}/restaurants/${id}/menu/items?${params}`
		);
		return response.data;
	}
};

export const syncMenuItems_api = async (restaurantId) => {
	if (restaurantId) {
		const response = await authenticatedApi.get(
			`${MICROSERVICE_CONFIG.RESTAURANT}/restaurants/${restaurantId}/menu/items?force_fetch_partner_menu=true`
		);
		return response.data;
	}
};

export const syncLunchboxImages_api = async (restaurantId) => {
	if (restaurantId) {
		const response = await authenticatedApi.post(
			`${MICROSERVICE_CONFIG.RESTAURANT}/external/restaurants/${restaurantId}/lunchbox/menu/updateImages`
		);
		return response.data;
	}
};
